interface SessionPromptsProps {
  showStartCue: boolean
  showSpeakFirstPrompt: boolean
  isScreenSharing: boolean
  showThankYou: boolean
}

export function SessionPrompts({
  showStartCue,
  showSpeakFirstPrompt,
  isScreenSharing,
  showThankYou,
}: SessionPromptsProps) {
  return (
    <>
      {showStartCue && !showThankYou && (
        <div className="absolute top-24 left-1/2 -translate-x-1/2 z-40 animate-fade-in-up pointer-events-none">
          <div className="bg-brand-600/90 text-white px-6 py-2 rounded-full shadow-[0_0_30px_rgba(42,71,66,0.4)] backdrop-blur-md border border-white/20">
            <span className="font-bold tracking-wider text-sm flex items-center gap-2">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
              INTERVIEW STARTED
            </span>
          </div>
        </div>
      )}

      {showSpeakFirstPrompt && !showThankYou && (
        <div className="absolute top-36 left-1/2 -translate-x-1/2 z-40 animate-fade-in-up pointer-events-none">
          <div className="bg-accent-500/80 text-black px-5 py-2.5 rounded-full shadow-[0_0_20px_rgba(234,179,8,0.3)] backdrop-blur-md border border-white/20">
            <span className="font-semibold tracking-wide text-sm flex items-center gap-2">
              <svg
                className="w-4 h-4 animate-pulse"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                />
              </svg>
              Say &ldquo;Hello&rdquo; or &ldquo;Hi&rdquo; to start
            </span>
          </div>
        </div>
      )}

      {isScreenSharing && !showThankYou && (
        <div className="absolute top-6 left-1/2 -translate-x-1/2 bg-accent-500/90 px-5 py-2 rounded-full border border-white/20 backdrop-blur-md z-10 flex items-center gap-2 pointer-events-none shadow-[0_0_20px_rgba(234,179,8,0.4)]">
          <div className="w-2.5 h-2.5 bg-white rounded-full animate-pulse" />
          <span className="text-xs text-black font-bold uppercase tracking-wide">
            Sharing Screen
          </span>
        </div>
      )}
    </>
  )
}
